/* eslint-disable import/no-anonymous-default-export */
// @domain
import {
    IParamsPercentageRequest,
    IPercentageResponse,
    ITotalPaidByUserResponse,
} from '../domain/interfaces/Dashboard';
import { IApiResponse } from '../domain/interfaces/Subscription';
import HttpService from './http.service';

const PercentageService = {
    getPercentageToBePaidToUser: async (params: IParamsPercentageRequest): Promise<IApiResponse<IPercentageResponse>> => {
        const URL = `/api/PercentageToBePaidToUser/by-user/${params.userId}?Year=${params.year}&Month=${params.month}&Page=${params.page}&PageSize=${params.pageSize}`;
        return new Promise<IApiResponse<IPercentageResponse>>((resolve, reject) => {
            HttpService.get(URL).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        })
    },

    getTotalPaidByUser: async (userId: string): Promise<IApiResponse<ITotalPaidByUserResponse>> => {
        const URL = `/api/PercentageToBePaidToUser/total-paid/${userId}`;
        return new Promise<IApiResponse<ITotalPaidByUserResponse>>((resolve, reject) => {
            HttpService.get(URL).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        })
    },

}

export default PercentageService;
